import * as React from 'react';
import { FC } from 'react';

interface IconProps {
  color?: string;
  size?: number;
  style?: React.CSSProperties;
}

const Unmute: FC<IconProps> = ({ color = 'white', size = 12, style }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="-5.0 -10.0 110.0 135.0" 
    fill={color} 
    style={style}
  >
    <path d="m64.199 59.102c-1.6992 0-3 1.3008-3 3 0 1.6992 1.3008 3 3 3 8.3008 0 15.102-6.8008 15.102-15.102s-6.8008-15.102-15.102-15.102c-1.6992 0-3 1.3008-3 3 0 1.6992 1.3008 3 3 3 5 0 9.1016 4.1016 9.1016 9.1016-0.10156 5-4.1016 9.1016-9.1016 9.1016z"/>
    <path d="m64.199 23.398c-1.6992 0-3 1.3008-3 3 0 1.6992 1.3008 3 3 3 11.301 0 20.602 9.1992 20.602 20.602 0 11.398-9.1992 20.602-20.602 20.602-1.6992 0-3 1.3008-3 3 0 1.6992 1.3008 3 3 3 14.699 0 26.602-11.898 26.602-26.602 0-14.699-12-26.602-26.602-26.602z"/>
    <path d="m27.102 35.301h-10.703c-2.3008 0-4.1016 1.8984-4.1016 4.1016v21.199c0 2.3008 1.8984 4.1016 4.1016 4.1016h10.699z"/>
    <path d="m51.199 79c0.60156 0 1.3008-0.19922 1.8984-0.5 1.3984-0.69922 2.1992-2.1016 2.1992-3.6992l0.003906-49.699c0-1.6016-0.89844-3-2.1992-3.6992-1.3984-0.69922-3-0.60156-4.3008 0.30078l-16.801 12.598v31.398l16.801 12.5c0.69922 0.60156 1.5977 0.80078 2.3984 0.80078z"/>
  </svg>
);

export default Unmute;